import request from '../../axios/axiosconfig.js'

/**
 * 查询门店列表
 * @param {*} params 
 * @returns 
 */
export function getAllPsStore(params) {
  return request({
    url: '/ps/psStore/getAllPsStore',
    method: 'get',
    params: params
  })
}

/**
 * 查询门店详情
 * @param {*} params 
 * @returns 
 */
export function getPsStoreDetail(params) {
  return request({
    url: '/ps/psStore/getBsCsByPsStoreId/'+params,
    method: 'get'
  })
}

/**
 * 根据id查询门店信息
 * @param {*} params 
 * @returns 
 */
export function getStoreInfoById(params) {
  return request({
    url: '/ps/psStore/getStoreInfoById/'+params,
    method: 'get'
  })
} 


export function updateStoreInfo(data) {
  return request({
    url: '/ps/psStore/updateStoreInfo',
    method: 'put',
    data: data
  })
} 

export function uploadImg(data) {
  return request({
    url: '/ps/common/uploadImg',
    method: 'put',
    data: data
  })
} 

/**
 * 统计门店订单
 * @param {*} params 
 * @returns 
 */
 export function getStoreStatics(params) {
  return request({
    url: '/ps/psStore/getStoreStatics/'+params,
    method: 'get'
  })
} 

/**
 * 查询门店订单列表
 * @param {*} params 
 * @returns 
 */
 export function getStoreOrders(params,data) {
  return request({
    url: '/ps/psStore/getStoreOrders/'+params,
    method: 'get',
    params: data
  })
} 




// WEBPACK FOOTER //
// ./src/api/storemanagement/psstore.js